'use client'
import { CheapestQuickestBadgeWidthContext } from '@/src/components/common/srp/cheapestQuickestCardLabel/cheapestQuickestNew'
import SwipeableDrawerWithBackNavigation from '@/src/components/common/ui/swipeableDrawer/swipeableDrawer'
import PercentIcon from '@mui/icons-material/Percent'
import { Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import React, { useContext, useState } from 'react'
import OfferDetailClient from '@/src/components/pages/offerDetail/OfferDetailClient'
import { getOfferSlugFromLink } from '@/src/utils/offerDetailUtils'

export interface PromoData {
    plink: string
    ptype: string
    ptext: string
}

interface YellowBannerPromoProps {
    promos?: PromoData[]
    isMobile?: boolean
    left?: number
}

const YellowBannerPromo: React.FC<YellowBannerPromoProps> = ({ promos, isMobile = false }) => {
    const badgeLeftOffset = useContext(CheapestQuickestBadgeWidthContext)
    const resolvedLeft = badgeLeftOffset
    const t = useTranslations('common')
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    if (!promos || promos.length === 0) {
        return null
    }

    const promo = promos[0]
    const offerSlug = getOfferSlugFromLink(promo.plink || '')

    const handleKnowMoreClick = (e: React.MouseEvent) => {
        if (isMobile) {
            e.preventDefault()
            e.stopPropagation()
            setIsDrawerOpen(true)
        }
    }

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false)
    }

    return (
        <>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: resolvedLeft,
                    backgroundColor: '#FEF4CC',
                    borderTopLeftRadius: resolvedLeft ? '0' : '8px',
                    borderBottomRightRadius: '8px',
                    borderBottomLeftRadius: resolvedLeft ? '8px' : 0,
                    padding: '4px 8px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    fontSize: '12px',
                    fontWeight: 500,
                    color: '#4A4A4A',
                    zIndex: 1,
                    height: '16px'
                }}
            >
                <Box
                    component="svg"
                    viewBox="0 0 12 12"
                    sx={{
                        backgroundColor: '#FCA402',
                        borderRadius: '50%',
                        width: 12,
                        height: 12,
                        display: 'flex',
                        padding: '0.5px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }}
                >
                    <PercentIcon sx={{ color: 'white', fontSize: 18 }} />
                </Box>

                <Box sx={{ flex: 1 }}>
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#333',
                            fontWeight: 500,
                            fontSize: '10px',
                            lineHeight: 1.5,
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {promo.ptext}
                    </Typography>
                </Box>

                {promo.plink && (
                    <Box
                        component={isMobile ? 'span' : 'a'}
                        href={isMobile ? undefined : promo.plink}
                        target={isMobile ? undefined : '_blank'}
                        rel={isMobile ? undefined : 'noopener noreferrer'}
                        onClick={handleKnowMoreClick}
                        sx={{
                            color: 'link.main',
                            fontWeight: 500,
                            fontSize: '10px',
                            textDecoration: 'none',
                            marginLeft: '4px',
                            whiteSpace: 'nowrap',
                            cursor: 'pointer',
                            '&:hover': {
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        {t('knowMore')}
                    </Box>
                )}
            </Box>

            {isMobile && (
                <SwipeableDrawerWithBackNavigation
                    open={isDrawerOpen}
                    onClose={handleCloseDrawer}
                    disableSwipeToOpen
                >
                    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                        {isDrawerOpen && offerSlug && (
                            <OfferDetailClient offerSlug={offerSlug} />
                        )}
                    </Box>
                </SwipeableDrawerWithBackNavigation>
            )}
        </>
    )
}

export default YellowBannerPromo
